<template>
    <div>
        <RebookableBadge
            v-if="product.IsRebookable"
            size="l"
            class="flight-modal-details-badge" />

        <Passengers :product="product" />

        <Divider color="lightGrey" bottomMargin="xxl" topMargin="xxl" thickness="1" />

        <Journeys
            type="Flight"
            direction="column"
            :legs="product.Legs"
            :showDetailed="true"
            :showHeaderBackground="false"
            :showHeader="product.Legs.length > 1" />
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import Journeys from '@/components/shared/Journey/Journeys.vue';
    import RebookableBadge from '@/components/shared/RebookableBadge/RebookableBadge.vue';
    import Passengers from './Passengers/Passengers.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'FlightModalDetails',
        components: {
            RebookableBadge,
            Journeys,
            Passengers,
            Divider,
        },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
    });
</script>
<style lang="scss" scoped>
    @forward 'Details';
</style>
